import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Copy = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.49875 3.88C4.49875 2.84 5.33833 2 6.37781 2H20.1209C21.1604 2 22 2.84 22 3.88V17.62C22 18.66 21.1604 19.5 20.1209 19.5H6.37781C5.33833 19.5 4.49875 18.66 4.49875 17.62V3.88ZM6.37781 3.26C6.03798 3.26 5.75812 3.53 5.75812 3.88V17.62C5.75812 17.97 6.02799 18.25 6.37781 18.25H20.1209C20.4608 18.25 20.7406 17.97 20.7406 17.62V3.88C20.7406 3.54 20.4708 3.26 20.1209 3.26H6.37781ZM2 5.12C2 4.78 2.26987 4.5 2.61969 4.5V4.51H3.67916C4.01899 4.51 4.29885 4.79 4.29885 5.13C4.29885 5.47 4.02899 5.75 3.67916 5.75H3.25937V20.13C3.25937 20.29 3.31934 20.45 3.43928 20.57C3.55922 20.68 3.70915 20.75 3.87906 20.75H18.2519V20.34C18.2519 19.99 18.5317 19.71 18.8716 19.71C19.2114 19.71 19.4913 19.99 19.4913 20.34V21.38C19.4913 21.72 19.2214 22 18.8716 22H3.87906C3.37931 22 2.89955 21.8 2.54973 21.45C2.1999 21.09 2 20.62 2 20.12V5.12Z"
    />
  </svg>
)

export default withDefaultStyles(Copy)
